import React from 'react';
import { string, shape, bool } from 'prop-types';
import { SVGComponent } from './SVG';
import styles from '../article-info.module.scss';

export const TimeAndDifficulty = ({ difficulty, duration }) => {
  return (
    <div className={styles['article-info__details__timeDifficulty']}>
      <div className={styles['article-info__details__timeDifficulty__difficulty']}>
        <SVGComponent name={difficulty.value} />
        <div
          className={styles['article-info__details__timeDifficulty__section']}
          data-testid="difficulty"
        >
          <p>
            <strong>Difficulty</strong>
          </p>
          <p>{difficulty.display}</p>
        </div>
      </div>
      <div className={styles['article-info__details__timeDifficulty__duration']}>
        <SVGComponent name={duration.value} />
        <div
          className={styles['article-info__details__timeDifficulty__section']}
          data-testid="duration"
        >
          <p>
            <strong>Duration</strong>
          </p>
          <p>{duration.display}</p>
        </div>
      </div>
    </div>
  );
};

TimeAndDifficulty.displayName = 'TimeAndDifficulty';

TimeAndDifficulty.propTypes = {
  difficulty: shape({
    display: string,
    selected: bool,
    value: string,
  }).isRequired,
  duration: shape({
    display: string,
    selected: bool,
    value: string,
  }).isRequired,
};
